export const LIST = '/mag';
export const WL = '/mag/:wl(wl)';
export const SEARCH = '/mag/search';

export const LIST_BY_RUBRICS = '/mag/rubrika/:rubric';
export const LIST_BY_PRODUCT = '/mag/:product(strakhovanie)';
export const LIST_BY_TAGS = '/mag/teg/:tag';

export const LIST_PARTNERS_WITH_TYPE = '/:organizationType/:organizationAlias/novosti';
export const MFO_LIST_PARTNERS_WITH_TYPE = '/zaimy/:organizationType(mfo)/:organizationAlias/novosti';
export const LIST_PARTNERS = '/:organizationAlias/novosti';

export const SPECIAL_PROJECTS = '/promo/:project(special-projects)';

export const NEWS = '/:type(novost)/:year(\\d+)/:month(\\d+)/:day(\\d+)/:alias';

export const MATERIAL = '/:type(text)/:alias';

// WIDGET FOR BANNER
export const WIDGET = '/novosti/:widget(widget)';

export const SURVEY = '/news/:survey(survey)/:surveyId';

export const SUBSCRIPTION_WIDGET = '/novosti/:widget(widget)/subscription';

export const SYNERGY_SUBSCRIPTION_WIDGET = '/novosti/:widget(widget)/subscription-synergy/:type(kolledzh)?';

// AMP PAGES

// LIST
export const AMP_LIST = '/amp/mag';
export const AMP_NEWS_LIST = '/amp/mag/rubrika/novosti';
export const AMP_LIST_BY_RUBRIC = '/amp/mag/rubrika/:rubric';
export const AMP_SPECIAL_OFFERS = '/amp-special-offers';

// SINGLE ARTICLES
export const AMP_SINGLE_NEWS = '/amp/:type(novost)/:year(\\d+)/:month(\\d+)/:day(\\d+)/:alias';
export const AMP_MATERIAL = '/amp/:type(text)/:alias';

export const PROPOSAL = '/article-proposal';
export const HANDLER_ROUTES = [PROPOSAL];

export const PAGES_WITHOUT_SUBSCRIPTION = [PROPOSAL];

const OLD_MATERIAL = '/:type(text)/:year(\\d+)/:month(\\d+)/:day(\\d+)/:alias';
const OLD_LIST = '/novosti';
const OLD_WL = '/novosti/:wl(wl)';
const OLD_LIST_BY_RUBRICS = '/novosti/rubrika/:rubric';
const OLD_LIST_BY_PRODUCT = '/novosti/:product(strakhovanie)';
const OLD_LIST_BY_TAGS = '/novosti/teg/:tag';
const OLD_AMP_NEWS_LIST = '/amp/novosti/rubrika/novosti';

export const REDIRECTS: [string, string][] = [
  [OLD_LIST, LIST],
  [OLD_WL, WL],
  [OLD_LIST_BY_RUBRICS, LIST_BY_RUBRICS],
  [OLD_LIST_BY_PRODUCT, LIST_BY_PRODUCT],
  [OLD_LIST_BY_TAGS, LIST_BY_TAGS],
  [OLD_MATERIAL, MATERIAL],
  [OLD_AMP_NEWS_LIST, AMP_NEWS_LIST],
];
